import auth from '../../auth'
import EmployeesShowAssignmentsIndexPage from '../../../components/Pages/employees/show/assignments/index'
import EmployeesShowAssignmentsCreatePage from '../../../components/Pages/employees/show/assignments/create'
import EmployeesShowAssignmentsEditPage from '../../../components/Pages/employees/show/assignments/edit'
import EmployeesShowAssignmentsShowPage from '../../../components/Pages/employees/show/assignments/show'

export default [
    {
        path: '/employees/:uuid/assignments/create',
        name: 'employees.show.assignments.create',
        component: EmployeesShowAssignmentsCreatePage,
        beforeEnter: auth.guard.user,
    },
    {
        path: '/employees/:uuid/assignments/:childUuid',
        name: 'employees.show.assignments.show',
        component: EmployeesShowAssignmentsShowPage,
        beforeEnter: auth.guard.user,
    },
    {
        path: '/employees/:uuid/assignments/:childUuid/edit',
        name: 'employees.show.assignments.edit',
        component: EmployeesShowAssignmentsEditPage,
        beforeEnter: auth.guard.user,
    },
    {
        path: '/employees/:uuid/assignments',
        name: 'employees.show.assignments',
        component: EmployeesShowAssignmentsIndexPage,
        beforeEnter: auth.guard.user,
    },

]
